<div class="site-wrapper">
  <!-- <ngx-loading-bar color="#FFF" [includeSpinner]="false"></ngx-loading-bar> -->
  <app-header
    *ngIf="!(mobileWebViewService.isMobileWebView$ | async)"
    [hideThemeButton]="hideThemeButton"
  ></app-header>
  <div class="site-container">
    <app-sidebar
      class="d-none d-md-block side-bar"
      data-testid="dashboard-sideMenu-item"
      [class.minify]="minifySidebar"
      [minify]="minifySidebar"
    ></app-sidebar>
    <div id="scrollArea" class="site-content" [class.specific]="oldLayout">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div
  class="fixed-bottom m-4 d-flex flex-column gap-3 notification-wrapper"
  *ngIf="{ isMobileWebView: isMobileWebView$ | async } as vm"
>
  <browser-notification-alert
    *ngIf="!vm.isMobileWebView"
  ></browser-notification-alert>
  <affiliate-notification-alert
    *ngIf="!vm.isMobileWebView"
  ></affiliate-notification-alert>
  <instant-buy-notification-alert
    *ngIf="!vm.isMobileWebView && instantBuyEnabled"
  ></instant-buy-notification-alert>
</div>
